export default __webpack_public_path__ + "assets/grand-condo-neuf-quebec.b1da28cb.webp";